<template>
  <v-container id="tag" fluid tag="section">
    <filter-form
      :filter-form="filterForm"
      :types="types"
      :priorities="priorities"
    />
    <tag-table :tags="tags" :types="types" :priorities="priorities" />
    <common-no-result v-if="!loading && totalItem === 0" />
    <v-row class="mt-4">
      <v-col cols="12" sm="6" />
      <v-col cols="12" sm="6">
        <v-pagination
          v-if="totalItem > limit"
          v-model="currentPage"
          class="justify-sm-end"
          :length="getTotalItem(totalItem)"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import FilterForm from "./components/FilterForm.vue";
import TagTable from "./components/TagTable";
import RepositoryFactory from "../../repositories/RepositoryFactory";

const TagRepository = RepositoryFactory.get("tag");
export default {
  components: { FilterForm, TagTable },
  data() {
    return {
      filterForm: {
        keyword: "",
        type: "",
      },
      currentPage: 1,
      limit: 10,
      totalItem: 0,
      tags: [],
      types: [],
      priorities: [],
      loading: false,
    };
  },
  watch: {
    currentPage: {
      handler() {
        this.getTagList();
      },
    },
    limit: {
      handler() {
        if (this.currentPage === 1) {
          this.getTagList();
        } else {
          this.currentPage = 1;
        }
      },
    },
  },
  async created() {
    this.getTagList();
    Bus.$on("tag-list-filter", (filterForm) => {
      this.filterForm = filterForm;
      this.currentPage = 1;
      this.getTagList();
    });
    Bus.$on("tag-list-reload", () => {
      this.getTagList();
    });
  },
  beforeDestroy() {
    Bus.$off("tag-list-filter");
  },
  methods: {
    async getTagList() {
      this.loading = true;
      const params = {
        limit: this.limit,
        page: this.currentPage,
        keyword: this.filterForm.keyword,
        type: this.filterForm.type,
      };
      const loader = this.$loading.show();
      const response = await TagRepository.list(params);
      loader.hide();
      this.loading = false;
      if (response.success) {
        this.types = _.get(response, "data.list_type_tag", []);
        this.priorities = [
          {
            value: 0,
            text: "Không ưu tiên",
          },
          {
            value: 1,
            text: "Ưu tiên",
          },
        ];
        this.tags = _.get(response, "data.list_tag", []).map((o) => {
          return {
            ...o,
            typeText: _.get(
              this.types.find((s) => s.value == o.type),
              "text",
              ""
            ),
            priorityText: _.get(
              this.priorities.find((s) => s.value == o.priority),
              "text",
              ""
            ),
          };
        });
        this.totalItem = this.tags.length;
      }
    },
  },
};
</script>
